<template>
  <section class="category_card_outer">
    <div class="container">
      <div class="category_card_inner flx">
        <category-card v-for="(item, i) in items" :key="i" :category="item"></category-card>
      </div>
    </div>
  </section>
</template>

<script>
import CategoryCard from './CategoryCard'
export default {
  name: 'CategoriesWall',
  props: {
    items: {
      type: Array,
      default: () => {}
    }
  },
  components: {
    CategoryCard
  }
}
</script>

<style scoped>

</style>
